var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topCap"},[_c('p',{staticClass:"t"},[_vm._v(_vm._s(_vm.t))]),_vm._v(" "),_c('p',{staticClass:"s"},[_vm._v(_vm._s(_vm.s))]),_vm._v(" "),_c('img',{attrs:{"src":_vm.$cdn + '/img/main/cap_' + _vm.page + '.svg'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }